import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type { FilterState } from '@/features/filterSlice';
import type { RedFlagWarning } from '@/features/wildfireSlice';

export const RedFlagWarningFilter = (props: {
  control: Control<FilterState>;
  redFlagWarnings: RedFlagWarning[] | undefined;
}) => {
  const warnings = props.redFlagWarnings?.map((w) => {
    return {
      value: w.id,
      label: w.area,
    };
  });
  return (
    <Controller
      control={props.control}
      name="redFlagWarnings"
      render={({ field: { onChange, onBlur, value } }) => {
        if (warnings && warnings.length > 0) {
          return (
            <InputSelect
              isMulti={true}
              label="Red Flag Warnings"
              placeholder="All Red Flag Warnings"
              options={warnings}
              onChange={onChange}
              onBlur={onBlur}
              value={warnings.filter((option) => value?.includes(option.value))}
            />
          );
        } else {
          return (
            <InputSelect
              isMulti={true}
              label="Red Flag Warnings"
              placeholder="Currently no warnings"
              options={[]}
              onChange={onChange}
              onBlur={onBlur}
              isDisabled={true}
              value={[]}
            />
          );
        }
      }}
    ></Controller>
  );
};
